import CryptoJS from 'crypto-js';

class StringHelper {
    static toTitleCase = (text) => {
        if (!text || text === "")
            return;
        text.toLocaleLowerCase();
        text = text.charAt(0).toLocaleUpperCase() + text.slice(1);
        return text
    }

    static hexToBytes(hex) {
        const bytes = new Uint8Array(hex.length / 2);
        for (let i = 0; i < hex.length; i += 2) {
            bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
        }
        return bytes;
    }

    static encryptWithTimeStamp = (data = "moockdata", timestamp = "1234564123168", apikey = "4f8G7k2Pq9Rz1Vx3Yb6Wm8Tn0Qs5Ld7Jp2Cv", iv = "1234567890abcdef") => {

        // base64(Data + Timestamp)
        const base64Data = btoa(data);

        // สร้าง SECRET
        const secret = apikey + timestamp;

        //encrypt AES-256-CBC

        var sha256Secret = CryptoJS.SHA256(secret)
        // var sha256SecretString = sha256Secret.toString(CryptoJS.enc.Hex)

        // const iv = StringHelper.hexToBytes("9f3d7a1c5b2e8d0f4a6b7c8e9d0f1a2b") // 16 bytes IV for AES-256-CBC

        const ivString = CryptoJS.enc.Utf8.parse(iv);
        // AES encrypt
        const encrypted = CryptoJS.AES.encrypt(base64Data, sha256Secret, {
            iv: ivString,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        const aes256Encrypted = encrypted.toString();

        return aes256Encrypted;
    }

    static decryptWithTimeStamp = (
        encryptedData,
        timestamp = "1234564123168",
        apikey = "4f8G7k2Pq9Rz1Vx3Yb6Wm8Tn0Qs5Ld7Jp2Cv",
        iv = "1234567890abcdef"
    ) => {
        // Recreate secret
        const secret = apikey + timestamp;

        // Derive SHA-256 key
        const sha256Secret = CryptoJS.SHA256(secret);

        // IV
        const ivString = CryptoJS.enc.Utf8.parse(iv);

        // AES decrypt
        const decrypted = CryptoJS.AES.decrypt(encryptedData, sha256Secret, {
            iv: ivString,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Convert from WordArray → Utf8
        const base64Data = decrypted.toString(CryptoJS.enc.Utf8);

        // Decode Base64 back to original data
        const originalData = atob(base64Data);

        return originalData;
    };


    static formatDuration = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const parts = [];
        if (hours > 0) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
        if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
        if (seconds > 0 || parts.length === 0) parts.push(`${seconds} second${seconds !== 1 ? 's' : ''}`);

        return parts.join(' ');
    };

    static SELECT_SEARCH_FILTER_LABEL_OPTION = (input, option) => (
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    )

    static SORT_NUM_STRING = (a, b) => {
        const isANumeric = /^\d+/.test(a);
        const isBNumeric = /^\d+/.test(b);

        if (isANumeric && isBNumeric) {
            const numA = parseInt(a.match(/^\d+/)[0], 10);
            const numB = parseInt(b.match(/^\d+/)[0], 10);
            return numA - numB;
        }

        if (isANumeric) return -1;
        if (isBNumeric) return 1;

        return a.localeCompare(b, undefined, { sensitivity: "base" });
    }
    static getReadableFileSizeString(fileSizeInBytes) {
        var i = -1;
        var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
        do {
            fileSizeInBytes = fileSizeInBytes / 1024;
            i++;
        } while (fileSizeInBytes > 1024);

        return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    };

    static getFormattedDurationFromSeconds(seconds) {
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds - hours * 3600) / 60);
        const secs = (seconds - hours * 3600 - mins * 60);

        const hoursString = ((hours < 10) ? "0" : "") + `${hours}`;
        const minsString = ((mins < 10) ? "0" : "") + `${mins}`;
        const secondsString = ((secs < 10) ? "0" : "") + `${secs}`;
        return `${hoursString}:${minsString}:${secondsString}`;
    }

    static extractURLBrandAndBranch(url) {
        const pathRegex = /^\/cms\/(\d+)(?:\/(\d+))?/;
        const match = url.match(pathRegex);

        return {
            brandid: match ? match[1] : undefined,
            branchid: match && match[2] ? match[2] : undefined,
        };
    }

    static getFormattedDurationToSeconds(durationString) {
        const durArr = durationString.split(":");

        const hours = durArr[0];
        const mins = durArr[1];
        const seconds = durArr[2];


        return parseInt(seconds) + parseInt(mins) * 60 + parseInt(hours) * 3600;
    }

    /**
     * Decodes a JWT token and returns the payload object.
     * Does NOT verify the signature — validation is done server-side.
     * @param {string} token – JWT string (header.payload.signature)
     * @returns {object|null} – decoded payload, or null if invalid
     */
    static decodeJWT(token) {
        try {
            const parts = token.split(".");
            if (parts.length !== 3) return null;
            // base64url → base64 → decode
            const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
            const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
            const json = decodeURIComponent(
                atob(padded)
                    .split("")
                    .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
                    .join("")
            );
            return JSON.parse(json);
        } catch (e) {
            console.warn("decodeJWT failed:", e);
            return null;
        }
    }

    /**
     * Returns the plan value from a JWT token.
     * @param {string} token – JWT string
     * @returns {number} – plan value (defaults to 1 = Lite if not present)
     */
    static getJWTPlan(token) {
        //1 = Lite, 2 = Pro, Defaults to 1 if token is invalid or plan not present.
        const defaultPlan = 2;
        if (!token) return defaultPlan;
        const payload = StringHelper.decodeJWT(token);
        if (!payload) return defaultPlan;
        return payload.plan ?? defaultPlan      ;
    }
}

export default StringHelper